import { PageController } from '@client/components/_core/layout/PageController';
import { InspectionReportOverlay } from '@client/components/claims/vehicle-inspection/InspectionReportOverlay';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute, notFound } from '@tanstack/react-router';

/**
 * The full report of one AI damage scan or photo run, opened from its card on the Vehicle tab.
 * Like the tab, no `featureFlag`: the server's vehicle product-type gate answers NOT_FOUND.
 */
export const Route = createFileRoute('/console/$orgId/claims/details/$id/vehicle/report/$inspectionId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Ravin AI report',
        },
    },
    params: {
        parse({ inspectionId }) {
            // An edited link's non-numeric segment is a 404, not a BigInt SyntaxError.
            if (!/^[1-9]\d*$/.test(inspectionId)) throw notFound();
            return {
                inspectionId: BigInt(inspectionId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { id, inspectionId } = Route.useParams();
    const navigate = useNavigate();
    return (
        <PageController route={Route}>
            <InspectionReportOverlay
                claimId={BigInt(id)}
                inspectionId={inspectionId}
                afterClose={() => navigate({ moveInMatches: -1 })}
            />
        </PageController>
    );
}
